<script setup>

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    text: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    }
});

const emit = defineEmits([])

const close = () => {
    emit('close')
}

const save = () => {
    emit('save')
}

</script>


<template>
    <el-dialog v-model="props.show" style="width: fit-content;" class="rounded rounded-4 delete-modal" :show-close="false">
        <template #header="{ close }" class="p-0">
            <div class="d-flex justify-content-end">
                <button type="button" class="btn p-0" @click="close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M15.5 5.5L5.5 15.5M5.5 5.5L15.5 15.5" stroke="#96959D" stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </template>

        <div class="text-center d-flex flex-column align-items-center justify-content-center gap-3">
            <img src="../assets/img/delete-dialog.png" alt="KMS" />

            <h2 class="fw-bold m-0">
                Delete {{ props.text }}
            </h2>

            <h2 class="fw-bold m-0" v-if="props.title?.length > 0">
                “{{ props.title }}”
            </h2>
            <h6 class="m-0">
                Are you sure to delete this {{ props.text }}?
            </h6>
        </div>

        <template #footer>
            <span class="dialog-footer d-flex align-items-center justify-content-center gap-2">
                <button type="button" class="btn outlineBtn" @click="close">
                    Cancel
                </button>

                <button type="button" class="btn btn-danger border px-4 py-3" @click="save">
                    Delete
                </button>
            </span>
        </template>
    </el-dialog>

</template>
